import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import { Container, DisplayHeading, Eyebrow } from '@/travo/components/ui/postmark';
import { useCopy } from '@/travo/i18n';
import { INK_RULE } from '@/travo/theme/constants';

/** Four steps on a dashed route, each marked with a double-ring postmark. */
const HowItWorks = () => {
  const copy = useCopy();

  return (
    <Container as="section" id="how" pt={{ base: '80px', md: '112px' }} pb="96px">
      <Flex direction="column" align="center" textAlign="center" gap="16px" mb="56px">
        <Eyebrow>{copy.how.eyebrow}</Eyebrow>
        <DisplayHeading fontSize={{ base: '34px', md: '54px' }}>{copy.how.title}</DisplayHeading>
      </Flex>

      <Box position="relative">
        <Box
          aria-hidden
          position="absolute"
          left="12%"
          right="12%"
          top="46px"
          borderTop="3px dashed"
          borderColor="ink"
          opacity={0.35}
          display={{ base: 'none', md: 'block' }}
        />
        <Grid as="ol" listStyleType="none" position="relative" templateColumns="repeat(auto-fit, minmax(220px, 1fr))" gap="40px 32px">
          {copy.how.steps.map((step, i) => (
            <Flex as="li" key={step.tag} direction="column" align="center" textAlign="center" gap="16px">
              <Flex
                w="92px"
                h="92px"
                borderRadius="full"
                bg="paper"
                border="3px solid"
                borderColor="stamp"
                boxShadow="inset 0 0 0 6px {colors.paper}, inset 0 0 0 8px {colors.stamp}"
                align="center"
                justify="center"
                fontFamily="heading"
                fontSize="34px"
                color="stamp"
              >
                {i + 1}
              </Flex>
              <Eyebrow fontSize="12px">{step.tag}</Eyebrow>
              <Heading as="h3" fontFamily="body" fontSize="21px" fontWeight="700">
                {step.title}
              </Heading>
              <Text fontSize="16px" color="inkSoft" maxW="20em">
                {step.body}
              </Text>
            </Flex>
          ))}
        </Grid>
      </Box>

      <Text
        mt="56px"
        mx="auto"
        maxW="46em"
        textAlign="center"
        fontSize="15px"
        color="inkSoft"
        border={INK_RULE.dashed}
        px="20px"
        py="14px"
      >
        {copy.how.note}
      </Text>
    </Container>
  );
};

export default HowItWorks;
